import React from "react";
import { Grid2 as Grid, Skeleton, useTheme } from "@mui/material";

export interface InvoiceCommentsLoadingProps {
  height?: number | string;
}

export default function InvoiceCommentsLoading({ height }: InvoiceCommentsLoadingProps) {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  return (
    <Grid
      container={true}
      flexDirection="column"
      flexWrap="nowrap"
      minHeight={150}
      maxHeight={height || "100%"}
      bgcolor={isDarkMode ? "#121212" : "common.white"}
      py={1}
      borderRadius={2}
    >
      <Grid
        container={true}
        flexDirection="column"
        flexWrap="nowrap"
        height="100%"
        flex="1 1 auto"
        pb={1}
        px={1.5}
        sx={{ overflowY: "auto" }}
      >
        {[...Array(1)].map((_, idx) => (
          <Grid key={idx} container={true} spacing={1} mb={2}>
            <Grid size={12} display="flex" gap={1.5}>
              <Skeleton variant="circular" width={40} height={40} />
              <Grid container={true} flexDirection="column" flex={1}>
                <Skeleton variant="text" width="30%" height={20} sx={{ mb: 0.5 }} />
                <Skeleton variant="rounded" width="100%" height={60} />
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
      <Grid component="footer" container={true} width="100%" pt={1} px={1.5} spacing={1}>
        <Grid size={12}>
          <Skeleton variant="rounded" width="100%" height={56} />
        </Grid>
      </Grid>
    </Grid>
  );
}
